var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uppercase flex h-screen text-2xl mt-20"},[_vm._v(" "+_vm._s(_vm.$t('home.contacts'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }